<template>
  <div class="jizhong">
    <!-- 浓缩液集中供液系统 -->
    <div class="nong">
      <div class="title">
        <titleCard title="Dialysis Concentrate Centralized Liquid Supply System"></titleCard>
      </div>
      <div class="cards">
        <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="0.8s">
          <h3>01</h3>
          <p>The hemodialysis centralized liquid supply system is mainly used for the preparation and automatic supply of concentrated dialysate or dialysate in hospital dialysis rooms.</p>
        </div>
        <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="1.2s">
          <h3>02</h3>
          <p>Dialysis concentrate needs to be mixed with hemodialysis water in the dialyzer. Only when the concentration meets the requirements of the dialyzer can the dialysis be carried out.</p>
        </div>
        <div class="card animate__animated wow animate__fadeInUp" data-wow-duration="1.6s">
          <h3>03</h3>
          <p>The dialysis concentrate centralized liquid supply system is suitable for many brands of dialysis machines.</p>
        </div>
      </div>
      <div class="IosCards">
        <div class="card animate__animated wow animate__fadeInLeft" data-wow-duration="1s">
          <h3>01</h3>
          <p>The hemodialysis centralized liquid supply system is mainly used for the preparation and automatic supply of concentrated dialysate or dialysate in hospital dialysis rooms.</p>
        </div>
        <div class="card animate__animated wow animate__fadeInLeft" data-wow-duration="1.4s">
          <h3>02</h3>
          <p>Dialysis concentrate needs to be mixed with hemodialysis water in the dialyzer. Only when the concentration meets the requirements of the dialyzer can the dialysis be carried out.</p>
        </div>
        <div class="card animate__animated wow animate__fadeInLeft" data-wow-duration="1.8s">
          <h3>03</h3>
          <p>The dialysis concentrate centralized liquid supply system is suitable for many brands of dialysis machines.</p>
        </div>
      </div>
      <div class="zhizhen animate__animated wow animate__fadeIn">
        <h3>The “Zhi Zhen” Series of Dialysis Centralized Liquid Supply System</h3>
        <div class="zhizhen-pic"><img src="../../assets/image/Industry/jizhong1.webp" alt=""></div>
        <p>Patent Number：ZL 202022184007.7</p>
      </div>
    </div>
    <!-- 设备特点 -->
    <div class="she">
      <div class="title animate__animated wow animate__fadeIn">
        <titleCard title="Features"></titleCard>
      </div>
      <!-- PC -->
      <div class="content-pic animate__animated wow animate__fadeIn">
        <img src="../../assets/image/Industry/jizhong2.png">
      </div>
      <!-- IOS -->
      <div class="content-ios">
        <div class="headimg"><img src="../../assets/image/Industry/jizhong1.webp" alt=""></div>
        <div class="boxs">
          <div class="box animate__animated wow animate__fadeInRight">
            <div class="pic">
              <img src="../../assets/image/Industry/ios1.webp" alt="">
            </div>
            <div class="txt">
              <p>Unique Stirring Design + Temperature Compensation<br>Guarantee rapid dissolution of dialysis powder</p>
              <span></span>
            </div>
          </div>
          <div class="box animate__animated wow animate__fadeInLeft">
            <div class="txt">
              <p class="p">triple check of concentration for more accuracy</p>
              <span></span>
            </div>
            <div class="pic">
              <img src="../../assets/image/Industry/ios2.webp" alt="">
            </div>

          </div>
          <div class="box animate__animated wow animate__fadeInRight">
            <div class="pic">
              <img src="../../assets/image/Industry/ios3.webp" alt="">
            </div>
            <div class="txt">
              <p>The “Zhi Chun” Series of High-Accuracy Multi-Stage Filtration Device</p>
              <span></span>
            </div>
          </div>
          <div class="box animate__animated wow animate__fadeInLeft">
            <div class="txt">
              <p class="p">systematic physical and chemical combined disinfection<br>Patent Number: ZL 201921416488.0</p>
              <span></span>
            </div>
            <div class="pic">
              <img src="../../assets/image/Industry/ios4.webp" alt="">
            </div>

          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-pic animate__animated wow animate__fadeIn">
          <img src="../../assets/image/Industry/jizhong3.webp" alt="">
        </div>
        <div class="footer-txt animate__animated wow animate__fadeIn">
          <p>Bidirectional U-Shaped Liquid Supply Assembly</p>
          <p>Independent R&D &nbsp;&nbsp; Dead Space-Free</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleCard from '@/components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  created() {

  },
  components: {
    titleCard
  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.jizhong {
  // 浓缩液集中供液系统
  .nong {
    .title {
      padding: 1.0211rem 0 1.1579rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 55px 0;
      }
    }
    .cards {
      display: flex;
      @media screen and (max-width: 540px) {
        display: none;
      }
      //   align-items: center;
      margin-bottom: 1.3474rem;
      justify-content: center;
      .card {
        width: 5.3895rem;
        padding-bottom: 20px;
        border: 1px solid #dbdbdb;
        margin: 0 0.1579rem;
        text-align: center;
        h3 {
          font-size: 0.5474rem;
          padding: 0.3211rem 0 0.4263rem 0;
          color: #0ca6eb;
          margin: 0;
        }
        p {
          font-size: 0.2526rem;
          color: #272b2d;
          text-align: left;
          line-height: 0.4211rem;
          padding: 0 0.5789rem;
        }
      }
    }
    .IosCards {
      display: none;
      padding: 0 15px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .card {
        width: 100%;
        height: 120px;
        background-color: #fbfbfb;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        h3 {
          color: #0ca6eb;
          font-size: 26px;
          margin: 0;
          padding: 0 12px;
        }
        p {
          font-size: 14px;
          color: #272b2d;
        }
      }
    }
    .zhizhen {
      height: 9.4737rem;
      background: url('../../assets/image/Industry/zhizhen-bg.webp') no-repeat;
      background-size: 100% 100%;
      text-align: center;
      @media screen and (max-width: 540px) {
        height: 360px;
      }
      h3 {
        color: #0ca6eb;
        margin: 0;
        padding-top: 1.3684rem;
        font-size: 0.4211rem;
        @media screen and (max-width: 540px) {
          font-size: 20px;
          padding-top: 54px;
        }
      }
      .zhizhen-pic {
        width: 12.3158rem;
        height: 5.2632rem;
        margin: 0 auto;
        margin-top: 0.5895rem;
        margin-bottom: 0.2526rem;
        @media screen and (max-width: 540px) {
          font-size: 20px;
          margin-top: 60px;
          width: 80%;
          height: 124px;
          margin-bottom: 22px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        color: #999999;
        font-size: 0.2947rem;
        @media screen and (max-width: 540px) {
          font-size: 14px;
        }
      }
    }
  }
  // 设备特点
  .she {
    .title {
      padding: 1.5789rem 0 0.8211rem 0;
    }
    .content-pic {
      width: 16.7368rem;
      height: 6.0632rem;
      margin: 0 auto;
      margin-bottom: 1.0947rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-ios {
      @media screen and (max-width: 540px) {
        display: block;
      }
      display: none;
      padding-top: 23px;
      .headimg {
        height: 138px;
        box-sizing: border-box;
        padding: 0 48px;
        margin-bottom: 22px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .boxs {
        .box {
          padding: 0 20px;
          height: 100px;
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          .pic {
            width: 100px;
            height: 100%;
            border-radius: 50px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .p {
            text-align: right;
          }
          .txt {
            padding: 0 16px;
            width: 70%;
            p {
              color: #272b2d;
              font-size: 14px;
              line-height: 25px;
              padding-bottom: 18px;
            }

            span {
              height: 1px;
              width: 100%;
              display: block;
              background-color: #d6d6d6;
            }
          }
        }
      }
    }
    .footer {
      width: 16.7368rem;
      height: 3.7684rem;
      margin: 0 auto;
      background: url('../../assets/image/Industry/jizhong-bg.webp') no-repeat;
      background-size: 100% 100%;
      margin-bottom: 0.7368rem;
      display: flex;
      align-items: center;
      @media screen and (max-width: 540px) {
        height: 200px;
        width: 100%;
        margin-bottom: 0;
      }
      .footer-pic {
        width: 4.0421rem;
        height: 3.4316rem;
        padding-left: 2.3895rem;
        @media screen and (max-width: 540px) {
          width: 192px;
          height: 162px;
          padding-left: 0;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .footer-txt {
        @media screen and (max-width: 540px){
          padding-right: 35px;
        }
        p {
          color: #333;
          font-size: 0.2947rem;
          line-height: 0.5263rem;
          font-weight: 500;
          @media screen and (max-width: 540px) {
            font-size: 15px;
            line-height: 25px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
